'use client';
import Image, { StaticImageData } from 'next/image';
import { BrandId } from 'utils/override';
import logoMH from './../../public/static-content/brand_icon_mh.svg';
import logoMM from './../../public/static-content/brand_icon_mm.svg';
import logoSS from './../../public/static-content/brand_icon_ss.svg';
import { useClientContext } from '$/modules/context/client';

const logos: Record<BrandId, StaticImageData | undefined> = {
  moneyhero: logoMH,
  singsaver: logoSS,
  moneymax: logoMM,
  money101: logoSS,
};

const altText: Record<BrandId, string> = {
  singsaver: 'Singsaver logo',
  moneyhero: 'MoneyHero logo',
  moneymax: 'MoneyMax logo',
  money101: 'Money101 logo',
};

export const BrandIcon = ({
  width = 26,
  height = 26,
  className,
}: {
  width?: number;
  height?: number;
  className?: string;
}) => {
  const context = useClientContext();
  const brand = context.brand;
  const logo = logos[brand];

  if (!logo) {
    return null;
  }

  return (
    <Image
      src={logo}
      width={width}
      height={height}
      alt={altText[brand]}
      className={className}
    />
  );
};
